import { useState } from "react";
import { Loader2, Lock } from "lucide-react";
import { LogoMark } from "../landing/Logo";
import { api, setToken, errorText } from "./api";

export const AdminLogin = ({ onLogin }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setToken(data?.token);
      onLogin(data?.user);
    } catch (err) {
      setError(errorText(err));
    } finally {
      setLoading(false);
    }
  };

  const input = "w-full rounded-2xl border border-mar/15 bg-white px-5 py-4 outline-none focus:border-mar focus:shadow-[0_0_0_4px_rgba(27,42,92,0.15)]";

  return (
    <div className="flex min-h-screen items-center justify-center bg-arena px-5">
      <form data-testid="admin-login-form" onSubmit={submit} className="w-full max-w-md rounded-[2rem] bg-white p-8 shadow-[0_30px_60px_-30px_rgba(27,42,92,0.4)] sm:p-10">
        <LogoMark className="h-16 w-16" />
        <h1 className="mt-6 font-display text-3xl font-extrabold text-mar">Panel de solicitudes</h1>
        <p className="mt-2 text-sm text-tinta/70">Acceso solo para el equipo de Jaha Brasilpe.</p>
        <div className="mt-8 space-y-4">
          <input data-testid="admin-login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" className={input} />
          <input data-testid="admin-login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Contraseña" className={input} />
        </div>
        {error && <p data-testid="admin-login-error" className="mt-4 text-sm font-semibold text-barro">{error}</p>}
        <button data-testid="admin-login-submit" disabled={loading} className="mt-6 flex w-full items-center justify-center gap-2 rounded-full bg-mar py-4 font-bold text-white transition-transform hover:-translate-y-0.5 disabled:opacity-70">
          {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : <Lock className="h-4 w-4" />} Entrar
        </button>
        <a href="/" className="mt-5 block text-center text-sm font-semibold text-mar/70 hover:text-mar" data-testid="admin-back-home">← Volver al sitio</a>
      </form>
    </div>
  );
};
